import { API } from "aws-amplify"

import { getBetaCode as GetBetaCode } from "../graphqlCustom/queries"

export default async function betaCodeExists(id) {
  const response = await API.graphql({
    authMode: "AWS_IAM",
    query: GetBetaCode,
    variables: {
      id,
    },
  })
  if (response.data.getBetaCode == null) {
    throw new Error("No code exists")
  }
  return true
}
